import { render, staticRenderFns } from "./TopLogin.vue?vue&type=template&id=5270031e"
import script from "./TopLogin.vue?vue&type=script&lang=ts"
export * from "./TopLogin.vue?vue&type=script&lang=ts"
import style0 from "./TopLogin.vue?vue&type=style&index=0&id=5270031e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports